import axios from 'axios'
import axiosInstance from '../../axios/axiosInstance'
import { RecordingUploadGrant, TasterStatus, TasterSubmitPayload } from 'types/tasterTypes'

// Teacher-feedback taster (one free Pro-style correction for Free learners,
// reached from the Day 0–5 re-engagement emails). The endpoints are being
// built concurrently with this UI, so every call fails soft.

export const getTasterStatus = async (): Promise<TasterStatus | null> => {
  try {
    const res = await axiosInstance.get(`taster/status`)
    return res?.data?.state ? res.data : null
  } catch (error) {
    return null
  }
}

// Errors are rethrown so the page can show the backend's message (403 { message } on ineligible).
export const submitTaster = async (payload: TasterSubmitPayload) => {
  const res = await axiosInstance.post(`taster/submit`, payload)
  return res?.data
}

// Same presigned-S3 flow the mobile story recorder uses: ask the backend for a
// short-lived PUT URL, upload the raw audio there, then reference the returned key.
export const createRecordingUploadUrl = async (
  storyId: string,
  contentType: string,
): Promise<RecordingUploadGrant> => {
  const res = await axiosInstance.post(`story-listening/recording/upload-url`, { storyId, contentType })
  return res?.data
}

// Plain axios on purpose: the presigned URL carries its own auth in the query
// string, and adding our Authorization header would invalidate the S3 signature.
export const uploadRecordingToPresignedUrl = async (uploadUrl: string, file: File | Blob, contentType: string) => {
  await axios.put(uploadUrl, file, { headers: { 'Content-Type': contentType } })
}
